'use strict';

const SELECTORS = {
    generalErrorContainer: '.error-messaging',
    successMessageContainer: '.success-messaging',
}

const createSuccessNotification = require('friartux/components/successNotification');
const cookieHelper = require('friartux/components/cookieHelper');

/**
 * @description Initializes events
 */

function init() {
    let promoCode = cookieHelper.getCookie('promoCode');
    let showPromoCodeMessage = cookieHelper.getCookie('showPromoCodeMessage');

    if (promoCode !== '' && showPromoCodeMessage === 'true') {
        createSuccessNotification($(SELECTORS.successMessageContainer), Resources.PROMO_CODE_MESSAGE_SUCCESS.replace('[promo-code]', promoCode), null, true, 'promo-code-notification');
        cookieHelper.deleteCookie('showPromoCodeMessage');
    }
}

module.exports = init();
